import store from "@/store/index";

export default (router) => {
  router.beforeEach(async (to, from, next) => {
    const isPublic = to.matched.some((record) => record.meta.public);
    const requiresAuth = !isPublic;

    if (to.name === "SetEmailVerify") {
      const { token } = to.params;
      if (token) {
        return next();
      } else {
        return next({ name: "Login" }); 
      }
    }

    if(to.name === "Logout") {
      next();
    }

    const isAuthenticated = await store.dispatch("auth/checkToken");
    if (isAuthenticated && (to.name === "Login" || to.name === "Register" || to.name === "ForgotPassword" || to.name === "ResetPassword")) {
      return next({ name: "Dashboard" }); 
    }

    if (requiresAuth && !isAuthenticated) {
      await store.dispatch("auth/logout");
      return next({ name: "Login" });
    }

    if (isAuthenticated) {
      await store.dispatch("user/checkUserStatus");
      const { emailVerified, hasActivePackage } = store.state.user;;
      if (!emailVerified && to.name !== "EmailVerify") {
        return next({ name: "EmailVerify" });
      }

      if (emailVerified && !hasActivePackage && to.name !== "Packages") {
        return next({ name: "Packages" });
      }
    }
    next();
  });
};